export default props => {
  const { as = 'h1', className, title } = props
  const As = as
  return <As className={className}>{title}</As>
}
